import React, { useState, useEffect } from "react";
import { Select } from "@windmill/react-ui";

import MenuServices from "services/MenuServices";

const SelectParent = ({
  register,
  name,
  defaultValue,
  required,
  onChange,
  label,
  selectedOptions,
  ...props
}) => {
  const [allParent, setParent] = useState([]);
  useEffect(() => {
    async function fetchParent() {
      try {
        const response = await MenuServices.getAllParent(1);


        setParent(response.data);
      } catch (error) {
        console.error("Error fetching category:", error);
      }
    }

    fetchParent();
  }, []);
  //   const filteredCategories = allParent.filter(
  //     (category) => category.vehcilecategory === vehicleType
  //   );

  return (
    <Select
      className="border h-10 text-sm focus:outline-none block w-full bg-white-100 dark:bg-white border-transparent focus:bg-white"
      name={name}
      {...register(name, required ? { required: `${label} is required!` } : {})}
      {...props}
      value={defaultValue}
      onChange={onChange}
    >
      <option value="">Select Model</option>
      {Array.isArray(allParent) && allParent.length > 0 ? (
        allParent.map((category) => (
          <option
            key={category.id_menu}
            value={category.id_menu}
            disabled={selectedOptions?.includes(String(category.id_menu))}
          >
            {category.name}
          </option>
        ))
      ) : (
        <option>Loading...</option>
      )}
    </Select>
  );
};

export default SelectParent;
